// LearningPathsConfig.ts
import {TECH_CONCEPTS_COURSES, LEARNING_TO_CODE_COURSES, PROGRAMMER_RESUMES_COURSES, TECH_INTERVIEW_PREP_COURSES} from "./CoursesConfig";
import {ALL_INTERVIEWS} from "./InterviewsConfig";
import {ALL_RESOURCES} from "./ResourcesConfig";
import {TOOL_TYPES_CONFIG} from "./ToolTypesConfig";
import ActionItemThumbnail from "../images/actionItem.webp"
import {ARTICLES_MARKUP} from "./ArticlesConfig";

export const ALL_CONTENT = {
    allCourses: [
        {
            header: "Learning to Code",
            subtitle: "Master the fundamentals and start your programming journey",
            navUrl: "/learning-to-code/",
            content: LEARNING_TO_CODE_COURSES
        },
        {
            header: "Tech Concepts",
            subtitle: "Understand the technologies that power modern software",
            navUrl: "/tech-concepts/",
            content: TECH_CONCEPTS_COURSES
        },
        {
            header: "Job Searching",
            subtitle: "Land your dream tech job with proven strategies",
            navUrl: "/job-searching/",
            content: PROGRAMMER_RESUMES_COURSES
        },
        {
            header: "Interview Prep",
            subtitle: "Ace technical interviews and showcase your skills",
            navUrl: "/tech-interview-prep/",
            content: TECH_INTERVIEW_PREP_COURSES
        },
    ],
    allAITools: [
        {
            header: "AI Tools",
            subtitle: "Leverage AI to enhance your job search and career growth",
            content: TOOL_TYPES_CONFIG
        }
    ],
    allBlogs: [
        {
            header: "Blog Posts",
            subtitle: "Insights, tips, and stories from the tech industry",
            content: ARTICLES_MARKUP
        }
    ],
    allInterviews: [
        {
            header: "Formal Interviews",
            subtitle: "Learn from real developers who made successful career transitions",
            navUrl: "/formal-interviews/",
            content: ALL_INTERVIEWS.FORMAL_INTERVIEWS
        },
        {
            header: "Mock Interviews",
            subtitle: "Practice and prepare with realistic interview scenarios",
            navUrl: "/mock-interviews/",
            content: ALL_INTERVIEWS.MOCK_INTERVIEWS
        }
    ],
    allResources: [
        {
            header: "Guides",
            subtitle: "Comprehensive guides to master essential programming concepts",
            navUrl: "/guides/",
            content: ALL_RESOURCES.GUIDES
        },
        {
            header: "Cheat Sheets",
            subtitle: "Quick reference materials for programming fundamentals",
            navUrl: "/cheat-sheets/",
            content: ALL_RESOURCES.CHEAT_SHEETS
        },
        {
            header: "Resume Examples",
            subtitle: "Real resume templates from successful tech professionals",
            navUrl: "/resume-examples/",
            content: ALL_RESOURCES.RESUME_EXAMPLES
        }
    ],
}

export const ALL_ACTION_ITEMS = {
    FIND_COURSE: {
        name: "Pick a specialty and find your first course",
        trackingId: "findCourse",
        thumbnail: ActionItemThumbnail
    },
    BUILD_FIRST_PROJECT: {
        name: "Build your first project (and save everything!)",
        trackingId: "buildFirstProject",
        thumbnail: ActionItemThumbnail
    },
    UPLOAD_GITHUB_PROJECT: {
        name: "Upload a project to GitHub",
        trackingId: "uploadProjectGithub",
        thumbnail: ActionItemThumbnail
    },
    BUILD_WITH_API: {
        name: "Build something that uses an API",
        trackingId: "buildWithAPI",
        thumbnail: ActionItemThumbnail
    },
    EXPLORE_LIBRARIES: {
        name: "Explore the most popular libraries/frameworks for your specialty",
        trackingId: "buildWithAPI",
        thumbnail: ActionItemThumbnail
    },
    WRITE_RESUME: {
        name: "Write a resume",
        trackingId: "writeResume"
    },
    WRITE_COVER_LETTER: {
        name: 'Write a "base" Cover Letter',
        trackingId: "writeCoverLetter"
    },
    PREPARE_INTERVIEW_QUESTIONS: {
        name: "Prepare your interview questions",
        trackingId: "prepareQuestions"
    }
}